import MemberApi from '@api/MemberApi'
import ClientOnboardingApi from '@api/ClientOnboardingApi'

export default {
  methods: {
    suggestLocationFromZipCode(zip) {
      return new MemberApi({ simulateExample: 'LocationInfo' })
        .getLocationDetailsFromZipCode({ zipCode: zip })
        .then(response => {
          let suggestion = null
          // returned as array with one response being the preferred suggestion
          if (Array.isArray(response)) {
            suggestion = response.find(r => r.preferred === true)
          } else { // returned as single object as the preferred suggestion
            suggestion = response
          }

          return suggestion
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    suggestLocationFromPublicUtilZipCode(zip) {
      return new ClientOnboardingApi({ simulateExample: 'LocationInfo' })
        .getLocationDetailsFromZipCode({ zipCode: zip })
        .then(response => {
          let suggestion = null
          // returned as array with one response being the preferred suggestion
          if (Array.isArray(response)) {
            suggestion = response.find(r => r.preferred === true)
          } else { // returned as single object as the preferred suggestion
            suggestion = response
          }

          return suggestion
        })
        .catch(error => {
          console.log('error', error)
        })
    }
  }
}
